<template>
  <section>
    <h4 v-if="displayNameVisibleValue && !titleSmall"
        :class="titleClass">
      {{displayNameValue}}
      <label v-if="requiredValue"
             class="text-danger fw-bold user-select-none">*</label>
    </h4>
    <h5 v-if="displayNameVisibleValue && titleSmall"
        :class="titleClass">
      {{displayNameValue}}
      <label v-if="requiredValue"
             class="text-danger fw-bold user-select-none">*</label>
    </h5>
    <label v-if="requiredValue && !displayNameVisibleValue"
           class="text-danger fw-bold user-select-none">*</label>
    <input :type="type"
           :value="modelValue"
           class="form-control"
           :class="inputClassValue"
           :placeholder="placeholder"
           v-on:input="$emit('update:modelValue', $event.target.value);" />
    <label v-if="countVisible"
           class="d-block text-end small text-secondary user-select-none"
           :class="labelClassValue">
      <template v-if="hasMaxCount && detailedCountDisplay">
        {{$t("basic_input.count_message_with_maxlength", {count: inputValueLength, maxlength: maxlengthValue})}}
      </template>
      <template v-if="hasMaxCount && !detailedCountDisplay">
        {{inputValueLength}}
        /
        {{maxlengthValue}}
      </template>
      <template v-if="!hasMaxCount && detailedCountDisplay">
        {{$t("basic_input.count_message", {count: inputValueLength})}}
      </template>
      <template v-if="!hasMaxCount && !detailedCountDisplay">
        {{inputValueLength}}
      </template>
    </label>
  </section>
</template>

<script>
  import { defineComponent } from "vue";
  import { getValueIgnoreCase } from "utils/json";

  export default defineComponent({
    props: {
      type: {
        type: String,
        default: "text",
        validator: (val) => {
          return ["email", "number", "password", "tel", "text", "url"].includes(val);
        },
      },
      titleSmall: {
        type: Boolean,
        default: false,
      },
      titleClass: {
        type: String,
        default: null,
      },
      inputClass: {
        type: String,
        default: null,
      },
      placeholder: {
        type: String,
        default: null,
      },
      labelClass: {
        type: String,
        default: null,
      },
      countVisible: {
        type: Boolean,
        default: true,
      },
      detailedCountDisplay: {
        type: Boolean,
        default: false,
      },
      attributes: {
        type: Object,
        default: {},
      },
      maxlength: {
        type: Number,
        default: null,
      },
      displayName: {
        type: String,
        default: null,
      },
      displayNameVisible: {
        type: Boolean,
        default: true,
      },
      required: {
        type: Boolean,
        default: null,
      },
      modelValue: {
        type: null,
        default: null,
      },
    },
    computed: {
      hasMaxCount() {
        return this.maxlengthValue > 0;
      },
      inputValueLength() {
        return this.modelValue == null ? 0 : this.modelValue.toString().length;
      },
      maxlengthValue() {
        if (this.maxlength != null && this.maxlength > 0) {
          return this.maxlength;
        }
        let attrMaxLength = getValueIgnoreCase(this.attributes, "maxlength");
        if (attrMaxLength > 0) {
          return attrMaxLength;
        }
        return 0;
      },
      displayNameValue() {
        if (this.displayName != null) {
          return this.displayName;
        }
        let attrdisplayName = getValueIgnoreCase(this.attributes, "displayName");
        if (attrdisplayName != null) {
          return attrdisplayName;
        }
        return "";
      },
      displayNameVisibleValue() {
        return (this.displayNameValue != null && this.displayNameValue.length > 0 && this.displayNameVisible);
      },
      requiredValue() {
        if (this.required != null) {
          return this.required;
        }
        let attrRequired = getValueIgnoreCase(this.attributes, "required");
        if (attrRequired != null) {
          return attrRequired;
        }
        return false;
      },
      inputClassValue() {
        if (this.inputClass != null) {
          return this.inputClass;
        }
        if (this.hasMaxCount && (this.inputValueLength > this.maxlengthValue)) {
          return "border-danger";
        }
      },
      labelClassValue() {
        if (this.labelClass != null) {
          return this.labelClass;
        }
        if (this.hasMaxCount && (this.inputValueLength > this.maxlengthValue)) {
          return "text-danger fw-bold";
        }
        if (this.hasMaxCount && (this.inputValueLength >= this.maxlengthValue - this.maxlengthValue * 0.1)) {
          return "text-warning";
        }
      }
    },
    data: () => {
      return {
      }
    },
    methods: {
    },
    created() {
    },
  });
</script>
